export default __webpack_public_path__ + "static/media/Statistics_2019.25628de3.zip";